export default __webpack_public_path__ + "static/media/guide20.e1f70aa3.png";